import React from "react";
import severUrl from "../../api";
import SearchPost from "./SearchPost";
import EditPost from "./EditPost";
import SearchSlug from "./SearchSlug";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Admin = ({ match }) => {

  const [slug, setSlug] = useState("")
  const navigate = useNavigate();


  const updateSlug = (new_slug) => {
    setSlug(new_slug)
    navigate('edit', { state: { slug: new_slug } });
  };

  const createNewPost = () => {
    navigate('edit', { state: { slug: "Dummy" } });
}

  return (<>
    <Routes>
      <Route
        path="searchpost"
        element={<SearchPost choice={updateSlug} createNewPost={createNewPost}/>}>
      </Route>
      <Route
        path="edit"
        element={<EditPost />}
      ></Route>
      <Route
        path="searchslug"
        element={<SearchSlug />}
      ></Route>
    </Routes>
  </>
  )
}

export default Admin;
